import { useRoute } from 'vue-router'
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import useSwapStore from '../store/swap'
import useAuthStore from '@/modules/Auth/store'
import useToastStore from '@/modules/Core/store/toast'

export default function useSwap() {
  const swapStore = useSwapStore()
  const route = useRoute()
  const toastStore = useToastStore()
  const { t } = useI18n()

  async function handleSwap(swap: string) {
    const authStore = useAuthStore()
    const isLoggedIn = authStore.loggedIn

    swapStore.setSwapId(swap)

    if (isLoggedIn) {
      swapStore.toggleSwapModal(true)
    } else {
      authStore.toggleAuthForm(true)
      toastStore.addToast({
        title: t('messages.swapLoginMessage'),
        color: 'success',
      })
    }
  }

  watch(
    () => route.query,
    (query) => {
      if (!query) {
        return
      }

      const swapId = query?.swap ?? ''

      if (swapId && typeof swapId === 'string' && swapId.trim() !== '') {
        handleSwap(swapId)
      }
    },
    { immediate: true }
  )

  return {}
}
